import {performHttpRequest} from "../http";

export async function getAnnouncements() {
    return performHttpRequest(
        window.kaartViewerUrl + '/admin/v2/kaartviewerapi/bookmark/' + window.websiteID + '/announcement',
        'GET',
    )
}
